import { useCallback, useState } from "react";
import { BlockProps } from "../types";
import { useBlock } from ".";

export interface UseFilesBlockArgs extends BlockProps {}

export const useFilesBlock = (args: UseFilesBlockArgs) => {
  const block = useBlock({ ...args, type: "files.files", select: (enduser) => enduser });

  const [showUploadForm, setShowUploadForm] = useState(false);

  const openUploadForm = useCallback(() => setShowUploadForm(true), []);
  const closeUploadForm = useCallback(() => setShowUploadForm(false), []);

  const enduser = block.enduserQuery.data;

  return {
    ...block,
    enduser,
    showUploadForm,
    openUploadForm,
    closeUploadForm,
  };
};
